import React, { useLayoutEffect, useState } from "react";

function measureSafeAreaTop() {
  try {
    const el = document.createElement("div");
    el.style.cssText =
      "position:absolute;top:0;left:0;visibility:hidden;padding-top:env(safe-area-inset-top)";
    document.body.appendChild(el);
    const px = parseFloat(getComputedStyle(el).paddingTop) || 0;
    document.body.removeChild(el);
    return px;
  } catch { return 0; }
}

function guessAndroidStatusBarPx() {
  const dpr = Math.max(1, window.devicePixelRatio || 1);
  // Typical status bar ~24dp; you can tweak this if needed
  return Math.round(24 * dpr);
}

export default function StatusBarStrip({
  color = "#047857",
  applyBodyPadding = true,
  zIndex = 50,
  /** Set to 0.5 to make it half as tall */
  scale = 1,
  /** Force a specific height in px (skips auto measurement) */
  heightPx,
}) {
  const [h, setH] = useState(0);

  useLayoutEffect(() => {
    const safe = measureSafeAreaTop();
    const ua = navigator.userAgent || "";
    const isAndroid = /Android/i.test(ua);

    const base =
      typeof heightPx === "number"
        ? heightPx
        : safe > 0
        ? safe
        : isAndroid
        ? guessAndroidStatusBarPx()
        : 0;

    const finalH = Math.max(0, Math.round(base * scale));
    setH(finalH);

    document.documentElement.style.setProperty("--status-bar-height", `${finalH}px`);
    if (applyBodyPadding) {
      document.body.style.setProperty("--status-bar-height", `${finalH}px`);
      document.body.style.paddingTop = `var(--status-bar-height)`;
    }

    return () => {
      if (applyBodyPadding) document.body.style.removeProperty("padding-top");
    };
  }, [applyBodyPadding, scale, heightPx]);

  if (h === 0) return null;

  return (
    <div
      aria-hidden
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: "var(--status-bar-height)",
        background: color,
        zIndex,
        pointerEvents: "none",
      }}
    />
  );
}
